import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import classNames from 'classnames';
import { Button, Icon, ListItemIcon, ListItemText, Popover, MenuItem, Typography, } from '@material-ui/core';
import {connect} from 'react-redux';
import * as quickPanelActions from 'main/quickPanel/store/actions';
import * as authActions from 'auth/store/actions';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router-dom';
import history from '../history';
import {API} from "../config";
import {withContext} from "./custom/StateProvider";

const moment = require('moment-timezone');
const momentDurationFormatSetup = require('moment-duration-format');
momentDurationFormatSetup(moment);

const marketdays = API.service('market-days');

//const notifications = Utils.app.service('notifications');

const styles = theme => ({
  root     : {
    display   : 'flex',
    alignItems: 'center',
    width     : '100%'
  },
  seperator: {
    width          : 1,
    height         : 64,
    backgroundColor: theme.palette.divider
  }
});



class MainToolbar extends Component {

  initialState = {
    data: {
      role: 'guest',
      data: {
        'displayName': '',
        'photoURL': 'assets/images/avatars/profile.jpg',
        'email': '',
        //      shortcuts: Utils.populateFooter(),
      }
    }
  }

  state = {
    userMenu: null,
    ident: '',
    dbuser:{},
    unreadCount:0,
    render:false,
    market:false,
    change:''
  };

  userMenuClick = event => {
    this.setState({userMenu: event.currentTarget});
  };

  userMenuClose = () => {
    this.setState({userMenu: null});
  };

  updateMarket = () => {
    /*const app = this;
    marketdays.find({query:{at:{$lt:moment.utc().format()},$limit:1,$sort:{at:-1}}}).then(s=>{
      if(s.total > 0){
        app.setState({
          market:s.data[0].marketAction
        })

        let qs={}
        if(s.data[0].marketAction === 'OPEN'){
          qs = {marketAction:'CLOSE'};
        } else {
          qs = {marketAction:'OPEN'};
        }

        marketdays.find({query:{...qs,at:{$gt:moment().tz("UTC").format()},$limit:10,$sort:{at:1}}}).then(c=> {
          if(c.total > 0) {
            app.setState({
              change: moment.tz(c.data[0].at,"UTC").tz('America/Curacao').calendar()
            })
          }
          this.timer = setTimeout(app.updateMarket(),1000)
        })
      }
    }).catch(e=>{
      console.log('Clock Update Failed',e);
      app.setState({
        market:false
      })
    })*/
  }

  closeMarket = () => {
    let payload = {
      at:moment.utc(),
      marketAction:'CLOSE',
      description:'Manual Close'
    };
    marketdays.create(payload);
  }

  openMarket = () => {
    let payload = {
      at:moment.utc(),
      marketAction:'OPEN',
      description:'Manual Open'
    };
    marketdays.create(payload);
  }

  componentDidMount() {
    const app = this;
    //this.updateMarket()

    this.timer = setTimeout(app.updateMarket(),1000)
  }

  render()
  {
    const {classes, user} = this.props;
    const {userMenu} = this.state;
    var controller = this;

    return (
      <div className={classNames(classes.root, "flex flex-row")}>

        <div className="flex flex-1">
            {/*<FuseShortcuts/>*/}
        </div>

        <div className="flex">
          {/*  {(this.state.market === 'OPEN') &&
          <div className={"h-64 bg-green-dark p-16"}>
            <div className={'inline-block'}>MARKET IS OPEN &nbsp;&nbsp;&nbsp;<br />Closing {this.state.change}&nbsp;&nbsp;&nbsp;</div>
            <Button className="h-32 bg-red hover:bg-red-lighter ml-6" style={{marginTop:'-2rem'}} onClick={this.closeMarket}>
              CLOSE THE MARKET?
            </Button>
          </div>
          }

          {(this.state.market === 'CLOSE') &&
          <div className={"h-64 bg-red-dark p-16"}>
            <div className={'inline-block'}>MARKET IS CLOSED &nbsp;&nbsp;&nbsp;<br />Opening {this.state.change}&nbsp;&nbsp;&nbsp;</div>
            <Button className="h-32 bg-green-dark hover:bg-green ml-6" style={{marginTop:'-2rem'}} onClick={this.openMarket}>
              OPEN THE MARKET?
            </Button>
          </div>
          }*/}

            <Button className="h-64" onClick={this.userMenuClick}>

              <div className="hidden md:flex flex-col ml-12 items-start">
                <Typography component="span" className="normal-case font-500 flex text-white">
                  {this.props.context.displayName}
                </Typography>
                <Typography className="text-11 capitalize text-grey-light">
                  {this.props.context.displayRole}
                </Typography>
              </div>

              <Icon className="text-16 ml-12 hidden sm:flex" variant="action">keyboard_arrow_down</Icon>
            </Button>


          <Popover
            open={Boolean(userMenu)}
            anchorEl={userMenu}
            onClose={this.userMenuClose}
            anchorOrigin={{
              vertical  : 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical  : 'top',
              horizontal: 'center'
            }}
            classes={{
              paper: "py-8"
            }}
          >
            {user.role === 'guest' ? (
              <React.Fragment>
                <MenuItem component={Link} to="/login">
                  <ListItemIcon>
                    <Icon>lock</Icon>
                  </ListItemIcon>
                  <ListItemText className="pl-0" primary="Login"/>
                </MenuItem>
                <MenuItem component={Link} to="/register">
                  <ListItemIcon>
                    <Icon>person_add</Icon>
                  </ListItemIcon>
                  <ListItemText className="pl-0" primary="Register"/>
                </MenuItem>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <MenuItem
                  onClick={() => {
                    API.logout().then(()=>{
                      var payload = controller.initialState.data;
                      controller.props.setUserData(payload)
                      controller.userMenuClose();

                      history.push({
                        pathname: '/login',
                        state   : {redirectUrl: '/login'}
                      });
                    });
                  }}
                >
                  <ListItemText className="pl-0" primary="Logout"/>
                </MenuItem>
              </React.Fragment>
            )}
          </Popover>

          <div className={classes.seperator}/>


            {/*<IconButton className="w-64 h-64" onClick={() => toggleQuickPanel(true)}>
                {(this.state.unreadCount > 0) &&
                <Badge className={classes.margin} badgeContent={this.state.unreadCount} color="primary">
                    <Icon>notifications</Icon>
                </Badge>
                }

                {(this.state.unreadCount === 0) &&
                    <Icon>notifications</Icon>
                }
            </IconButton>*/}

        </div>

      </div>
    );
  }
}

function mapDispatchToProps(dispatch)
{
  return bindActionCreators({
    toggleQuickPanel: quickPanelActions.toggleQuickPanel,
    logout          : authActions.logoutUser,
    setUserData     : authActions.setUserData,
  }, dispatch);
}


function mapStateToProps({auth})
{
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(MainToolbar)));
